import { hooks } from '@approvalmax/utils';
import { useMount } from 'react-use';
import { shouldOpenNewOrgPopupNoCompaniesQueryParam, shouldOpenNewOrgPopupStorageKey } from 'shared/constants';

export const useNewOrgPopupNoCompaniesSave = () => {
    const [openNewOrg] = hooks.useQueryParam(shouldOpenNewOrgPopupNoCompaniesQueryParam);

    useMount(() => {
        if (openNewOrg) {
            sessionStorage.setItem(shouldOpenNewOrgPopupStorageKey, 'true');
        }
    });
};
